/* eslint-disable vymo-ui/restrict-import */
import React, { useCallback, useRef } from 'react';
import { Button, Input } from 'src/@vymo/ui/atoms';
import Form from 'src/@vymo/ui/molecules/form';
import { ReactComponent as LocationIcon } from 'src/assets/icons/location.svg';
import { FormVersion } from '../../molecules/form/types';
import styles from './index.module.scss';

function AdditionalInputs({
  value,
  onChange,
  onClose,
}: {
  value: any;
  onChange: any;
  onClose: any;
}) {
  const formRef = useRef(null);

  const onClickFormSave = useCallback(async () => {
    // @ts-ignore
    const result = await formRef.current?.getFieldsForSubmission?.();
    const additionalData = result.data?.reduce((acc, input) => {
      acc[input.code] = { value: input.value };
      return acc;
    }, {});
    onChange({ ...value, additional_details: additionalData });
    onClose();
  }, [onChange, onClose, value]);
  return (
    <div className={styles.additionalForm}>
      <div className={styles.additionalForm__formWrapper}>
        <Input
          type="text"
          label="Pin Location"
          disabled
          value={value?.formatted_address || ''}
          iconRight={<LocationIcon />}
        />
        <Form
          // @ts-ignore
          ref={formRef}
          id="testForm"
          name="testForm"
          onChange={() => {}}
          span="1fr"
          className={styles.additionalForm__inputs}
          config={{
            version: FormVersion.platform,
            data: [
              {
                code: 'address_line_1',
                type: 'input',
                hint: 'Address Line 1',
              },
              {
                code: 'address_line_2',
                type: 'input',
                hint: 'Address Line 2',
              },
              {
                code: 'landmark',
                type: 'input',
                hint: 'Landmark',
              },
            ],
            grouping: [],
          }}
          value={value?.additional_details || {}}
        />
      </div>
      <Button
        className={styles.additionalForm__submitButton}
        onClick={onClickFormSave}
      >
        Save
      </Button>
    </div>
  );
}

export default AdditionalInputs;
